import GetLessonLecturerAssignmentStatusLookupRequestModelBase from '../_generated/modelBases/get-lesson-lecturer-assignment-status-lookup-request-model-base';

export default class GetLessonLecturerAssignmentStatusLookupRequestModel extends GetLessonLecturerAssignmentStatusLookupRequestModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/155/ViewModels-Models-DTOs
}
